import { TreeProps } from "antd";
import { PropsWithChildren } from "react";
import { StyledTree } from "./atom";

export function Tree({
  className = "",
  ...props
}: PropsWithChildren<TreeProps>) {
  return (
    <StyledTree className={`renderbus-ui--tree ${className}`} {...props} />
  );
}
